module.exports = __webpack_public_path__ + "mv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mv.svg
// module id = 966
// module chunks = 0